<template>
  <div class="info">
    <p>Чат работает в режиме тестирования.</p>
    <p>
      Сервис — для связи с врачом по вопросам назначенного лечения: корректировка
      терапии, подбор аналогов препаратов и т. п. Врач может не отвечать на вопросы,
      не связанные с текущим лечением.
    </p>
    <p>
      Доступ предоставляется на время лечения (14 дней) или по подписке (пакеты
      обслуживания — ведение беременности, патронаж и др.).
    </p>
    <p>Врач отвечает в течение 24 часов в свою ближайшую смену по графику клиники.</p>
    <p>
      Доступен выбор пациента (если есть прикреплённые члены семьи) и врача,
      проводившего приём. История переписки сохраняется и после окончания лечения.
    </p>
  </div>
</template>

<script>
export default {
  name: 'ChatInfo',
};
</script>

<style scoped>
.info {
  background: var(--surface-2, #e9f8ff);
  border: 1px solid var(--border, #d3e9f2);
  border-radius: 12px;
  padding: 14px 16px;
  font-size: 14px;
  line-height: 1.5;
  color: var(--text-muted, #5c5c5c);
}

.info p {
  margin: 0 0 10px;
}

.info p:last-child {
  margin-bottom: 0;
}
</style>
